import React from 'react';
import cx from 'classnames';
import { useStaticQuery, graphql } from 'gatsby';

import { useSiteMetadata } from '../../utils/useSiteMetadata';
import { Button } from '../Button/Button';
import { Link } from '../Link/Link';

import * as cs from './SubmitError.module.css';

interface Props {
  show: boolean;
  onCancel: () => void;
  className?: string;
  withContact?: boolean;
}

export const SubmitError = ({
  show,
  onCancel,
  className,
  withContact,
}: Props) => {
  const data = useStaticQuery(graphql`
    query SubmitErrorQuery {
      snippet(slug: { eq: "submit_error" }) {
        id
        data
      }
    }
  `);

  const snippet: CustomTypes.SubmitErrorSnippet = data.snippet.data;

  const { email } = useSiteMetadata();

  const content = withContact ? (
    <>
      {snippet.error}{' '}
      <Link
        trackEvent="contact-us-email-form-error"
        className={cs.link}
        to={`mailto:${email}`}
      >
        {email}
      </Link>
    </>
  ) : (
    snippet.errorNoContact
  );

  return show ? (
    <div
      className={cx(cs.submitError, className)}
      style={
        {
          '--rgb-theme-text': '255 255 255',
          '--opacity-theme-text': '10%',
          '--color-theme-text': 'rgb(var(--rgb-theme-text))',
          '--color-theme-text-opacity':
            'rgb( var(--rgb-theme-text) / var(--opacity-theme-text) )',
        } as React.CSSProperties
      }
    >
      <div className={cs.submitErrorText}>{content}</div>

      <Button
        variant="translucent"
        size="sm"
        theme="current_text"
        onClick={onCancel}
      >
        {snippet.cancel}
      </Button>
    </div>
  ) : null;
};
